import React from "react";
import {
    CheckCircleIcon,
    ExclamationTriangleIcon,
    InformationCircleIcon,
    XCircleIcon,
    XMarkIcon,
    } from "@heroicons/react/24/outline";


// Configuracion visual de cada variante del modal
    const variantConfig = {
    success: {
        icon: CheckCircleIcon,
        iconBg: "tw-bg-green-100",
        iconColor: "tw-text-green-600",
        confirmButton: "tw-bg-green-600 hover:tw-bg-green-700 focus:tw-ring-green-500",
    },
    danger: {
        icon: XCircleIcon,
        iconBg: "tw-bg-red-100",
        iconColor: "tw-text-red-600",
        confirmButton: "tw-bg-red-600 hover:tw-bg-red-700 focus:tw-ring-red-500",
    },
    warning: {
        icon: ExclamationTriangleIcon,
        iconBg: "tw-bg-yellow-100",
        iconColor: "tw-text-yellow-600",
        confirmButton: "tw-bg-yellow-500 hover:tw-bg-yellow-600 focus:tw-ring-yellow-500",
    },
    info: {
        icon: InformationCircleIcon,
        iconBg: "tw-bg-blue-100",
        iconColor: "tw-text-blue-600",
        confirmButton: "tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-ring-blue-500",
    },
    };

    const ConfirmModal = ({
    show,
    title = "Confirmar acción",
    message = "¿Estás seguro de que querés continuar?",
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    variant = "warning",
    isLoading = false,
    onConfirm,
    onCancel,
    onClose,
    }) => {
    if (!show) return null;

    // busca la configuracion visual correspóndiente a la variante recibida, si la variante no existe, usa "warning" por defecto
    const currentVariant = variantConfig[variant] || variantConfig.warning;
    const Icon = currentVariant.icon;

    const handleCancel = () => {
        if (isLoading) return;

        if (onCancel) {
        onCancel();
        return;
        }

        if (onClose) {
        onClose();
        }
    };

    const handleClose = () => {
        if (isLoading) return;

        if (onClose) {
        onClose();
        }
    };

    return (
        <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-px-4">
        <div
            className="tw-absolute tw-inset-0 tw-bg-black/40 tw-backdrop-blur-sm"
            onClick={handleClose}
        />

        <div className="tw-relative tw-z-10 tw-w-full tw-max-w-md tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-xl">
            <button
            type="button"
            onClick={handleClose}
            disabled={isLoading}
            className="tw-absolute tw-right-4 tw-top-4 tw-rounded-full tw-p-1 tw-text-gray-400 tw-transition hover:tw-bg-gray-100 hover:tw-text-gray-600 disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
            >
            <XMarkIcon className="tw-h-6 tw-w-6" />
            </button>

            <div className="tw-flex tw-flex-col tw-items-center tw-text-center">
            <div
                className={`tw-mb-4 tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full ${currentVariant.iconBg}`}
            >
                <Icon className={`tw-h-8 tw-w-8 ${currentVariant.iconColor}`} />
            </div>

            <h2 className="tw-mb-2 tw-text-xl tw-font-semibold tw-text-gray-900">
                {title}
            </h2>

            <p className="tw-mb-6 tw-text-sm tw-leading-6 tw-text-gray-600">
                {message}
            </p>

            <div className="tw-flex tw-w-full tw-gap-3">
                <button
                type="button"
                onClick={handleCancel}
                disabled={isLoading}
                className="tw-flex-1 tw-rounded-xl tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-py-2.5 tw-text-sm tw-font-medium tw-text-gray-700 tw-transition hover:tw-bg-gray-50 disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
                >
                {cancelText}
                </button>

                <button
                type="button"
                onClick={onConfirm}
                disabled={isLoading}
                className={`tw-flex-1 tw-rounded-xl tw-px-4 tw-py-2.5 tw-text-sm tw-font-medium tw-text-white tw-transition focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-70 ${currentVariant.confirmButton}`}
                >
                {isLoading ? (
                    <span className="tw-flex tw-items-center tw-justify-center tw-gap-2">
                    <span className="tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-white tw-border-t-transparent" />
                    Cargando
                    </span>
                ) : (
                    confirmText
                )}
                </button>
            </div>
            </div>
        </div>
        </div>
    );
};

export default ConfirmModal;